export default __webpack_public_path__ + "static/media/AcceleronsGallery_22.c9409db5.JPG";